import optionDecider from "./optionDecider";

export default function parseSwitch(xmlNode) {
  const options: [] = Array.from(xmlNode.children);
  return optionDecider(options, xmlNode.getAttribute("type"));
}
